const actions = {
    PINCODE_DETAILS_START: 'PINCODE_DETAILS_START',
    PINCODE_DETAILS_SUCCESS: 'PINCODE_DETAILS_SUCCESS',
    PINCODE_DETAILS_FAILURE: 'PINCODE_DETAILS_FAILURE',

    AREA_DETAILS_START: 'AREA_DETAILS_START',
    AREA_DETAILS_SUCCESS: 'AREA_DETAILS_SUCCESS',
    AREA_DETAILS_FAILURE: 'AREA_DETAILS_FAILURE',


    CITY_DETAILS_START: 'CITY_DETAILS_START',
    CITY_DETAILS_SUCCESS: 'CITY_DETAILS_SUCCESS',
    CITY_DETAILS_FAILURE: 'CITY_DETAILS_FAILURE',

    STATE_DETAILS_START: 'STATE_DETAILS_START',
    STATE_DETAILS_SUCCESS: 'STATE_DETAILS_SUCCESS',
    STATE_DETAILS_FAILURE: 'STATE_DETAILS_FAILURE',

    COUNTRY_DETAILS_START: 'COUNTRY_DETAILS_START',
    COUNTRY_DETAILS_SUCCESS: 'COUNTRY_DETAILS_SUCCESS',
    COUNTRY_DETAILS_FAILURE: 'COUNTRY_DETAILS_FAILURE',

    LANGUAGE_DETAILS_START: 'LANGUAGE_DETAILS_START',
    LANGUAGE_DETAILS_SUCCESS: 'LANGUAGE_DETAILS_SUCCESS',
    LANGUAGE_DETAILS_FAILURE: 'LANGUAGE_DETAILS_FAILURE',

    CLEAR_ADDRESS_DETAILS_START: 'CLEAR_ADDRESS_DETAILS_START',
    CLEAR_ADDRESS_DETAILS_SUCCESS: 'CLEAR_ADDRESS_DETAILS_SUCCESS'
};

export default actions;